module.exports = __webpack_public_path__ + "slidernav_left.svg";